import React from 'react';
import {Box, Grid, IconButton, Typography, useMediaQuery, useTheme} from "@mui/material";
import ISwiper from "../../../../components/iSwiper/ISwiper";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {GetState} from "../../../../redux/reduxhelper";
import {IS_AUTH} from "../../../../redux/action/type.action";
import {useNavigate} from "react-router";
import {getCustomerListApi} from "../../../../api/ClientApi";
import {useQuery} from "react-query";
import Loading from "../../../../components/Site/Loading/Loading";

const Customer = () => {

    const isAuth = GetState(IS_AUTH, false)
    const navigate = useNavigate();
    const theme = useTheme();
    const biggerThanSmall = useMediaQuery(theme.breakpoints.up('sm'));
    const slidePerView = biggerThanSmall ? 3 : 1;

    const getCustomerList = async () => {
        try {
            const res = await getCustomerListApi(1, 10)
            return res?.data?.data
        } catch (e) {

        }
    }

    const {
        isLoading,
        data: customers,
    } = useQuery(['customers'], getCustomerList);

    if (isLoading) return <Loading/>;

    return (
        <Box sx={{
            width: '100vw',
            display: 'flex',
            flexDirection: "column",
            minHeight: '400px',
            alignItems: 'center',
            justifyContent: 'center',

        }}>
            <Grid sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                maxWidth: '1300px',
                margin: '20px',
                width: "100%",
            }}>
                <Grid sx={{display: "flex", flexDirection: "column", width: "100%", m: 3, padding: "20px"}}>
                    <Typography variant={"h6"} sx={{color: "rgba(109, 110, 118,0.6)"}}>برخی از</Typography>
                    <Typography variant={"h4"} sx={{color: "#6D6E76", fontWeight: 700,}}>مشتریان</Typography>
                </Grid>
            </Grid>

            <Grid sx={{width: "80vw"}}>
                {isAuth && <Grid sx={{textAlign: "right"}}>
                    <IconButton sx={{color: "#592EA9", cursor: "pointer"}}
                                onClick={() => navigate('admin/dashboard/customers')}>
                        <EditOutlinedIcon/>
                    </IconButton>
                </Grid>}
                <ISwiper slidePerView={slidePerView}>
                    {
                        customers?.map((c, i) => <Grid key={i} sx={{
                            minHeight: 196,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <img src={c?.image_url} alt="logo"/>
                        </Grid>)
                    }
                </ISwiper>
            </Grid>
        </Box>


        // <Box sx={{
        //     width: '100vw',
        //     display: 'flex',
        //     flexDirection: "column",
        //     minHeight: '400px',
        //     alignItems: 'center',
        //     justifyContent: 'center',
        //
        // }}>
        //     <Grid sx={{
        //         display: "flex",
        //         flexDirection: "column",
        //         alignItems: "center",
        //         maxWidth: '1300px',
        //         margin: '20px',
        //         width: "100%",
        //     }}>
        //         <Grid sx={{display: "flex", flexDirection: "column", width: "100%", m: 3, padding: "20px"}}>
        //             <Typography variant={"h6"} sx={{color: "rgba(109, 110, 118,0.6)"}}>برخی از</Typography>
        //             <Typography variant={"h4"} sx={{color: "#6D6E76", fontWeight: 700,}}>مشتریان</Typography>
        //         </Grid>
        //
        //         <Grid gap={3} sx={{
        //             display: "flex",
        //             flexDirection: {md: "row", xs: "column"},
        //             justifyContent: "center",
        //             alignItems: "center",
        //             width: "100%",
        //             flexWrap:'wrap'
        //         }}>
        //             <Grid sx={{mb: {xs: 1}, md: 0}}>
        //                 <img src={img6} alt="logo"/>
        //             </Grid>
        //             <Grid sx={{mb: {xs: 1}, md: 0}}>
        //                 <img src={img2} alt="logo"/>
        //             </Grid>
        //             <Grid sx={{mb: {xs: 1}, md: 0}}>
        //                 <img src={img1} alt="logo"/>
        //             </Grid>
        //
        //             <Grid sx={{mb: {xs: 1}, md: 0}}>
        //                 <img src={img3} alt="logo"/>
        //             </Grid>
        //             <Grid sx={{mb: {xs: 1}, md: 0}}>
        //                 <img src={img4} alt="logo"/>
        //             </Grid>
        //             <Grid sx={{mb: {xs: 1}, md: 0}}>
        //                 <img src={img5} alt="logo"/>
        //             </Grid>
        //
        //         </Grid>
        //     </Grid>
        // </Box>
    );
};

export default Customer;

